import { useQuery, gql, useLazyQuery } from '@apollo/client';
import { AlocacaoPageQuery } from './__generated__/AlocacaoPageQuery';

const ALOCACAO_PAGE_QUERY = gql`
  query AlocacaoPageQuery {
    professores {
      id_professor
      dsc_nome_professor
      dsc_email
      dsc_num_telefone
      flag_casa
    }
    cursos {
      id_curso
      dsc_nome_curso
        dsc_sigla_curso
      ativo
      ofertas {
        id_oferta
        num_oferta
        num_ano
        num_semestre
        ativa
        turmas {
          id_turma
          num_turma
        }
      }
    }
    disciplinas {
      id_disciplina
      dsc_nome_disciplina
      dsc_sigla
      num_carga_horaria
    }
    periodos {
      id_periodo
      dsc_periodo
      dat_inicio
      dat_fim
    }
    horarios {
      id_horario
      hora_inicio
      hora_fim
    }
  }
`;

const useAlocacaoPageQuery = () => {
  return useQuery<AlocacaoPageQuery>(ALOCACAO_PAGE_QUERY);
};

const useAlocacaoPageLazyQuery = () => {
  return useLazyQuery<AlocacaoPageQuery>(ALOCACAO_PAGE_QUERY);
};

export { useAlocacaoPageQuery, useAlocacaoPageLazyQuery };
